import { CanMatchFn } from '@angular/router';

import { shellNativeSignIn } from 'src/app/services/auth-bridge.service';

/**
 * The pages under native/ mirror the auth portal for the packaged mobile app. They are lazy routes of the web build
 * too, so without this a web visitor could open /login/native, /login/native/signup, /email-action or
 * /onboarding/native just by typing the address, and get a second, portal-less way to sign in.
 *
 * Only the mobile shell matches (it is what exposes native sign-in). Anywhere else the route simply does not exist:
 * `false` lets the router fall through to the next route, exactly as before these pages were added.
 */
export const nativeShellOnlyGuard: CanMatchFn = () => !!shellNativeSignIn();
